import "select2";

(function ($) {

    "use strict";

    // javascript code here. i.e.: $(document).ready( function(){} ); 
    $(document).ready(function () {
        let select = $('select').not('.woocommerce .checkout .form-row select, .woocommerce-shipping-totals  select, .news-filter-select');
        select.select2({
            minimumResultsForSearch: Infinity,
        });

        $('.news-filter-select').each(function () {
            const $select = $(this);

            $select.select2({
                minimumResultsForSearch: Infinity,
                dropdownParent: $select.parent()
            });
        });
    });

})(jQuery);